export default __webpack_public_path__ + "images/1e45887024c8a6113fbb9115faae1f0e.svg";